import React from "react";
import Select from "react-select";
import theme from "./theme";

const Dropdown = ({
  options = [],
  value,
  onChange,
  label,
  disabled = false,
  variant = "default",
  placeholder = "Select...",
  containerStyle = {},
  styles: userStyles = {},
  menuPortalTarget,
}) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: variant === "compact" ? "32px" : "38px",
      borderRadius: "6px",
      backgroundColor: "white",
      borderColor: state.isFocused ? theme.colors.primary : "#ccc",
      boxShadow: state.isFocused ? `0 0 0 1px ${theme.colors.primary}` : "none",
      "&:hover": { borderColor: theme.colors.primary },
      fontFamily: theme.typography.fontFamily,
      color: theme.colors.text,
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "white",
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? theme.colors.primary
        : state.isFocused
        ? "#f2f2f2"
        : "white",
      color: state.isSelected ? "white" : "black",
      cursor: "pointer",
    }),
    singleValue: (base) => ({
      ...base,
      color: theme.colors.text,
    }),
  };

  const mergedStyles = { ...customStyles, ...userStyles };

  const normalizedValue =
    typeof value === "object"
      ? value
      : options.find((opt) => opt.value === value) || null;

  return (
    <div
      style={{
        display: "inline-block",
        marginRight: "8px",
        width: "200px",
        ...containerStyle,
      }}
    >
      {label && (
        <label
          style={{
            display: "block",
            fontSize: "13px",
            marginBottom: "4px",
            color: theme.colors.text,
            fontFamily: theme.typography.fontFamily,
          }}
        >
          {label}
        </label>
      )}
      <Select
        styles={mergedStyles}
        options={options}
        value={normalizedValue}
        onChange={(selected) => onChange(selected ? selected.value : "")}
        isDisabled={disabled}
        isSearchable={false}
        placeholder={placeholder}
        menuPortalTarget={menuPortalTarget || document.body}
        menuPosition="fixed"
      />
    </div>
  );
};

export default Dropdown;